import React from 'react';
import { Switch, Redirect, Route, useLocation } from 'react-router-dom';
import { Backtesting } from 'scenes/backtesting';
import { DeniedAccess } from 'scenes/DeniedAccess';
import { MarketDataPage } from 'scenes/marketdata';
import { Jobs } from 'scenes/jobs';
import { NewMetrics, EditMetric, Metrics } from 'scenes/metrics';
import {
  NewReport,
  EditReport,
  ConfigReport,
  ReportsReport,
  SummaryReport,
} from 'scenes/reportsList';
import {
  PortfoliosBenchmark,
  PortfoliosFunds,
  PortfoliosMapping,
} from 'scenes/portfolios';
import { SideBarMenu } from 'scenes/sidebar/SideBarMenu';
import { Page } from 'shared/components/Page';
import * as ROUTES from 'routes';

export const AppRoutes: React.FC = (): JSX.Element => {
  const { search } = useLocation();
  return (
    <>
      <SideBarMenu />
      <Page windowTitle="">
        <Switch>
          <Redirect
            exact
            from={ROUTES.ROOT}
            to={{ pathname: ROUTES.REPORTS, search }}
          />

          <Route path={ROUTES.DASHBOARD}>
            <DeniedAccess />
          </Route>

          <Route path={ROUTES.JOBS}>
            <Jobs />
          </Route>

          <Redirect
            exact
            from={ROUTES.SIGN_IN}
            to={{ pathname: ROUTES.REPORTS, search }}
          />

          <Redirect
            exact
            from={ROUTES.PORTFOLIOS}
            to={ROUTES.PORTFOLIOS_FUNDS}
          />

          <Route path={ROUTES.PORTFOLIOS_FUNDS}>
            <PortfoliosFunds />
          </Route>

          <Route path={ROUTES.PORTFOLIOS_BENCHMARKS}>
            <PortfoliosBenchmark />
          </Route>

          <Route path={ROUTES.PORTFOLIOS_MAPPINGS}>
            <PortfoliosMapping />
          </Route>

          <Redirect exact from={ROUTES.REPORTS} to={ROUTES.REPORTS_SUMMARY} />

          <Route path={ROUTES.REPORTS_NEW_REPORT}>
            <NewReport />
          </Route>

          <Route path={ROUTES.REPORTS_EDIT_REPORT}>
            <EditReport />
          </Route>

          <Route path={ROUTES.REPORTS_CONFIG_REPORT}>
            <ConfigReport />
          </Route>

          <Route path={ROUTES.REPORTS_BACKTESTING}>
            <Backtesting />
          </Route>

          <Route path={ROUTES.REPORTS_SUMMARY}>
            <SummaryReport />
          </Route>

          <Route path={ROUTES.REPORTS_REPORT}>
            <ReportsReport />
          </Route>

          <Route path={ROUTES.JOBS}>
            <DeniedAccess />
          </Route>

          <Route path={ROUTES.MARKET_DATA}>
            <MarketDataPage />
          </Route>

          <Route path={ROUTES.METRICS_NEW_METRIC}>
            <NewMetrics />
          </Route>

          <Route path={ROUTES.METRICS_EDIT_METRIC}>
            <EditMetric />
          </Route>

          <Route path={ROUTES.METRICS}>
            <Metrics />
          </Route>
        </Switch>
      </Page>
    </>
  );
};
